<template lang="pug">
div
  menu-dropdown
  div.loyalty-tabs
    ods-tabs(v-model="activeTab" v-on:click.native="changeTable" v-if="showTable")
      ods-tab-pane(:label="this.$t('loyalty.generalData')" name="general")
        general-table(:data="this.data")
      ods-tab-pane(:label="this.$t('loyalty.operationaldata')" name="operativos")
        operativos-table(:data="this.data")
      ods-tab-pane(:label="this.$t('loyalty.automaticaward')" name="premio")
        premio-table(:data="this.data")
      ods-tab-pane(:label="this.$t('loyalty.commerces')" name="comercios")
        comercio-table(:activarComercios="showComercios")
</template>
<script>
import LoyaltyDropDown from '@/components/loyalty/LoyaltyDropDown'
import GeneralTable from '@/components/loyalty/programs/GeneralTable'
import OperativosTable from '@/components/loyalty/programs/OperativosTable'
import PremioTable from '@/components/loyalty/programs/PremioTable'
import ComercioTable from '@/components/loyalty/programs/ComercioTable'
import CanalesTable from '@/components/loyalty/programs/CanalesTable'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'LoyaltyPrograms',
  data () {
    return {
      activeTab: '',
      data: {},
      commerceData: {},
      canalData: {},
      oldProgram: null,
      commerceIsChange: false,
      canalesIsChange: false,
      showCanales: false,
      showComercios: false,
      showTable: false
    }
  },
  components: {
    'menu-dropdown': LoyaltyDropDown,
    'general-table': GeneralTable,
    'operativos-table': OperativosTable,
    'premio-table': PremioTable,
    'comercio-table': ComercioTable,
    'canales-table': CanalesTable
  },
  computed: {
    ...mapGetters({
      appProgramTitle: 'getSelectedProgram',
      getLang: 'getLang',
      loadingOptionMenu: 'getLoadingOptionMenu'
    })
  },
  methods: {
    ...mapActions(['getProgram', 'getCommerce', 'getCanales']),
    async changeTable (event) {
      this.showCanales = false
      this.showComercios = false
      if (!this.commerceIsChange) {
        if (event.target.id.toLowerCase() === 'tab-comercios') {
          this.showComercios = true
        }
      }
      if (!this.canalesIsChange) {
        if (event.target.id.toLowerCase() === 'tab-canales') {
          this.showCanales = true
        }
      }
    }
  },
  watch: {
    async appProgramTitle (data, oldData) {
      this.commerceIsChange = false
      this.canalesIsChange = false
      this.oldProgram = oldData
      const response = await this.getProgram()
      // console.log(response)
      this.data = response
      return this.data
    },
    async getLang (data, oldData) {
      this.commerceIsChange = false
      this.canalesIsChange = false
      const response = await this.getProgram()
      this.data = response
      return this.data
    },
    async loadingOptionMenu (data, oldData) {
      if (!this.loadingOptionMenu) {
        const getConfig = await this.$store.dispatch('getConfig')
        const response = await this.getProgram(getConfig)
        this.data = response
        this.showTable = true
        this.activeTab = 'general'
      }
    }
  },
  async mounted () {
    if (!this.loadingOptionMenu) {
      const getConfig = await this.$store.dispatch('getConfig')
      // console.log(getConfig)
      const response = await this.getProgram(getConfig)
      this.data = response
      this.showTable = true
      this.activeTab = 'general'
      return this.data
    }
  }
}

</script>
<style lang="scss" scoped>
.loyalty-tabs{
  padding: rem(0) rem(16);
}
</style>
